var LayoutIndexes;
(function (LayoutIndexes) {
    LayoutIndexes[LayoutIndexes["content"] = 1] = "content";
    LayoutIndexes[LayoutIndexes["formModal"] = 5] = "formModal";
    LayoutIndexes[LayoutIndexes["header"] = 10] = "header";
    LayoutIndexes[LayoutIndexes["modal"] = 20] = "modal";
    LayoutIndexes[LayoutIndexes["popover"] = 100] = "popover";
    /**
     * @internal popovers that do not use the Portal like the MegaMenu
     */
    LayoutIndexes[LayoutIndexes["popoverOutsidePortal"] = 101] = "popoverOutsidePortal";
    /**
     * @internal
     */
    LayoutIndexes[LayoutIndexes["skipToContent"] = 110] = "skipToContent";
})(LayoutIndexes || (LayoutIndexes = {}));
export default LayoutIndexes;
